import { render } from "./newInvoiceForm.vue?vue&type=template&id=064bce5a&scoped=true"
import script from "./newInvoiceForm.vue?vue&type=script&lang=js"
export * from "./newInvoiceForm.vue?vue&type=script&lang=js"

import "./newInvoiceForm.vue?vue&type=style&index=0&id=064bce5a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-064bce5a"]])

export default __exports__